import React from "react";
import lipsHCLogo from "./../../../../Assets/lipsHCLogo.svg";
import { motion } from "framer-motion";
import useBookingApp from "../../../../hooks/useBookingApp";

export default function BFLeftContent({
  activeStep,
  renderStepContentLeft,
  logo,
}) {
    const { bookingSectionState } = useBookingApp();
    const { companyDetails } = bookingSectionState;
    const pharmacyName = companyDetails?.pharmacies[0].pharmacyName;
  return (
    <div className="inner-content">
      <img className="logo" src={logo} alt={pharmacyName} />
      <div className="content">{renderStepContentLeft(activeStep)}</div>
    </div>
  );
}
